import { Navigate } from 'react-router-dom';
import { useAuth } from './authContext';

const ProtectedRoute = ({ element: Component, allowedRoles, ...rest }) => {
  const { isAuthenticated, role } = useAuth();

  if (!isAuthenticated) {
    // If not authenticated, redirect to login
    return <Navigate to="/" />;
  }

  if (!allowedRoles.includes(role)) {
    // If user doesn't have the right role, redirect to a "Not Authorized" page or home
    return <Navigate to="/" />;
  }

  // If authenticated and has the right role, render the component
  return <Component {...rest} />;
};

export default ProtectedRoute;
